"use client";

import { Calendar03Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useVolunteerRegistration } from "./volunteer-registration-provider";

export function VolunteerHeroDescription() {
  return useVolunteerRegistration().view.heroDescription;
}

export function VolunteerCloseDate() {
  const { view } = useVolunteerRegistration();
  return <>Close date: {view.closeDateLabel}</>;
}

export function VolunteerRegistrationFact() {
  const { view } = useVolunteerRegistration();
  return (
    <div className="flex min-w-0 flex-col items-center gap-1 border-r border-border/70 px-2 py-4 text-center last:border-r-0 sm:px-4">
      <HugeiconsIcon aria-hidden="true" icon={Calendar03Icon} strokeWidth={1.8} />
      <strong className="font-display text-lg text-foreground sm:text-2xl">{view.statusLabel}</strong>
      <span className="font-sans text-[0.625rem] text-muted-foreground sm:text-xs">
        <VolunteerCloseDate />
      </span>
    </div>
  );
}
